<template>
  <v-text-field
    v-bind="{ ...$attrs, ...$props }"
    class="text-input text-body-1"
    :class="{ 'text-input_disabled': disabled }"
    background-color="bg-gray-40"
    height="48px"
    dense
    solo
    flat
    outlined
    hide-details
    v-on="$listeners"
  >
    <template #prepend-inner>
      <svg
        class="search-icon b-icon b-icon-search"
        :class="{ 'search-icon_disabled': disabled }"
        width="20"
        height="20"
      >
        <use xlink:href="/static/_v1/pd/svg-sprites/global.svg#icon-search" />
      </svg>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'CommonSearchField',
  props: {
    disabled: Boolean,
  },
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.text-input {
  &.v-text-field--outlined {
    fieldset {
      border-color: $ui-kit-bg-gray-40;
    }

    &.v-input--is-focused fieldset {
      border-color: $ui-kit-primary;
    }
  }

  &_disabled.v-input input {
    &::placeholder {
      color: $ui-kit-disabled;
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.search-icon {
  color: $ui-kit-text-secondary;
  padding: 0 4px 0 0;

  &_disabled {
    color: $ui-kit-icon-secondary;
  }
}
</style>
